import PageLayout from './PageLayout';
import { FAQ } from '@/components/wedding';

const FAQPage = () => (
  <PageLayout testId="faq-page">
    <FAQ />
  </PageLayout>
);

export default FAQPage;
